import { createSlice } from "@reduxjs/toolkit";

export const ticketStatusSlice = createSlice({
  name: "ticketStatus",
  initialState: {
    getTicketStatusResult: false,
    getTicketStatusLoading: false,
    getTicketStatusError: false,
    addTicketStatusResult: false,
    addTicketStatusLoading: false,
  },
  reducers: {
    ticketStatusReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_TICKETSTATUS":
          return {
            ...state,
            getTicketStatusResult: payload.data,
            getTicketStatusLoading: payload.loading,
            getTicketStatusError: payload.error,
          };
        case "ADD_TICKETSTATUS":
          return {
            ...state,
            addTicketStatusResult: payload.data,
            addTicketStatusLoading: payload.loading,
          };
        default:
          return state;
      }
    },
  },
});

export const { ticketStatusReducers } = ticketStatusSlice.actions;

export default ticketStatusSlice.reducer;
